var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sk-spin",class:{
        'sk-spin-white':_vm.color == 'white'
    }},[_c('div',{staticClass:"sk-wave",style:({
            width: (_vm.px + "px"),
            height: (_vm.px + "px"),
        })},[_c('div',{staticClass:"sk-wave-rect"}),_c('div',{staticClass:"sk-wave-rect"}),_c('div',{staticClass:"sk-wave-rect"}),_c('div',{staticClass:"sk-wave-rect"}),_c('div',{staticClass:"sk-wave-rect"})])])}
var staticRenderFns = []

export { render, staticRenderFns }